document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('[data-size-guide-modal]');
  const openButton = document.querySelector('[data-size-guide-open]');
  const closeButtons = document.querySelectorAll('[data-size-guide-close]');

  if (!modal || !openButton) return;

  function openSizeGuide() {
    modal.hidden = false;
    document.body.classList.add('size-guide-open');

    const closeButton = modal.querySelector('.size-guide-close');

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeSizeGuide() {
    modal.hidden = true;
    document.body.classList.remove('size-guide-open');

    openButton.focus();
  }

  openButton.addEventListener('click', openSizeGuide);

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeSizeGuide);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeSizeGuide();
    }
  });
});